export interface CoverImageFieldProps {
  value: File | undefined
  rawValue: string | undefined
  onChange: (value: File) => void
  error?: string

  acceptedFileFormats: string
  topAddon?: React.ReactNode

  label: string
  placeholder: string
  uploadFileButtonLabel: string
  description: string
}
